export default __webpack_public_path__ + "static/media/error.7c3a9a8e.svg";